/**
 * Gallery category definitions.
 *
 * Categories displayed in the nav bar are derived from this list (single
 * source of truth) — do not hardcode category labels elsewhere.
 */

interface CategoryDefinition {
  id: string;
  label: string;
}

export const categoryDefinitions = [
  { id: 'about', label: 'About' },
  { id: 'blog', label: 'Blog' },
  { id: 'graphics', label: 'Graphics' },
  { id: 'mathematics', label: 'Math' },
  { id: 'photography', label: 'Film' },
] as const satisfies readonly CategoryDefinition[];

export type CategoryType = (typeof categoryDefinitions)[number]['id'];

export const categoryOrder: CategoryType[] = categoryDefinitions.map((category) => category.id);

export const defaultCategory: CategoryType = 'about';

export function getCategoryLabel(category: CategoryType): string {
  return categoryDefinitions.find(({ id }) => id === category)?.label ?? category;
}

export function isCategoryType(value: string | null): value is CategoryType {
  return value !== null && (categoryOrder as string[]).includes(value);
}

/** Categories where tiles are always displayed in their expanded state with no close button. */
export const alwaysExpandedCategories = new Set<CategoryType>(['graphics', 'mathematics'] as CategoryType[]);
